import html2canvas from 'html2canvas'; // 추가
import React, { useState, useEffect, useRef } from "react";
import { Header, Button } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { useLocation, useNavigate } from "react-router-dom";
import Wordnetwork from "../components/Wordnetwork";
import KeywordRelationshipTable from "../components/KeywordRelationshipTable";
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";
import { KeywordsWordCloud } from "../data/dummy";

const VisualizeWordnetworkDetail = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();
  const location = useLocation();
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  const [keywords, setKeywords] = useState(location.state?.keywords || KeywordsWordCloud);
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});
  const [graphData, setGraphData] = useState(location.state?.graphData || { nodes: [], links: [] });
  const [showPalette, setShowPalette] = useState(false);
  const [palettePosition, setPalettePosition] = useState({ top: 0, left: 0 });
  const paletteRef = useRef();

  const initializeGraphData = (data) => {
    setGraphData(data);
  };

  const handleLinkColorChange = (args) => {
    const newColor = args.currentValue.hex;
    setGraphData((prevData) => ({
      ...prevData,
      links: prevData.links.map((link) => ({
        ...link,
        color: newColor, // 새 색상 적용
      })),
    }));
    setShowPalette(false); // 팔레트 닫기
  };

  const handleColorChange = (keyword, color) => {
    setKeywordColors((prevColors) => ({
      ...prevColors,
      [keyword]: color,
    }));
  };

  const togglePalette = (e) => {
    const buttonRect = e.target.getBoundingClientRect();
    setPalettePosition({
      top: buttonRect.bottom + window.scrollY,
      left: buttonRect.left + window.scrollX,
    });
    setShowPalette((prev) => !prev);
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);
    
    const handleClickOutside = (e) => {
      if (paletteRef.current && !paletteRef.current.contains(e.target)) {
        setShowPalette(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, []);

  const goBack = () => {
    navigate("/vis/wordnetwork", {
      state: {
        keywordColors: { ...keywordColors }, // 불변성 유지
        graphData: { ...graphData }, // 불변성 유지
      },
    });
  };

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <Button
        color="white"
        bgColor={currentColor}
        text="이전 페이지"
        borderRadius="10px"
        onClick={goBack}
      />
      <div className="flex gap-5">
        <Header
          category="데이터 시각화"
          title="키워드 네트워크 연경망 편집 페이지 - 기능/UIUX 긍정 리뷰"
        />
      </div>
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        {/* <div className="flex justify-end">
          <button
            onClick={togglePalette}
            style={{
              backgroundColor: currentColor,
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            링크 색상 변경
          </button>
          {showPalette && (
            <div
              ref={paletteRef}
              style={{
                position: "absolute",
                top: `${palettePosition.top}px`,
                left: `${palettePosition.left}px`,
                zIndex: 1000,
                background: "#fff",
                border: "1px solid #ccc",
                padding: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <ColorPickerComponent
                mode="Palette"
                modeSwitcher={false}
                inline
                showButtons={false}
                change={handleLinkColorChange}
              />
            </div>
          )}
        </div> */}
        <div className="flex justify-between">
          <div className="flex-[4]">
            <Wordnetwork
              id="positive"
              keywordColors={keywordColors}
              initializeGraphData={initializeGraphData}
              graphData={graphData}
            />
          </div>
          <div className="flex-[1]">
            <KeywordRelationshipTable
              keywordColors={keywordColors}
              onColorChange={handleColorChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualizeWordnetworkDetail;
